import * as React from 'react';
import { useAtomValue } from 'jotai';
import { Space, theme } from 'antd';
import { LoadingOutlined, WarningOutlined, SwapRightOutlined } from '@ant-design/icons';
import { useCriticalEvents } from '@src/services/queries';
import * as store from '../../store';
import { useDropoffStatus } from '../../utils';
import * as Styles from './styled';

const DropoffIndicator = () => {
  const { data: criticalEvents, isFetching: isCriticalEventsFetching } = useCriticalEvents();
  const dropoffIndex = useAtomValue(store.dropOffIndexAtom);
  const pattern = store.useDashboardPattern();
  const dropoffStatus = useDropoffStatus(isCriticalEventsFetching);
  const { token } = theme.useToken();

  return (
    <>
      {dropoffStatus === 'FETCHING' && <LoadingOutlined />}
      {dropoffStatus === 'INSUFFICIENT_STEPS' && (
        <Space style={{ padding: '4px 8px', color: token.colorErrorText }}>
          <WarningOutlined style={{ fontSize: 20 }} />
          Add more steps to the funnel to see dropoff reasons
        </Space>
      )}
      {(dropoffStatus === 'AVAILABLE' || dropoffStatus === 'INVALID_STEP_PROPAGATION') && (
        <>
          <Styles.DropoffTitle>
            <Space size={8}>
              {criticalEvents?.criticalEventMap.get(pattern[dropoffIndex - 1])?.name ||
                pattern[dropoffIndex - 1]}
              <SwapRightOutlined />
              {criticalEvents?.criticalEventMap.get(pattern[dropoffIndex])?.name ||
                pattern[dropoffIndex]}
            </Space>
          </Styles.DropoffTitle>

          {dropoffStatus === 'INVALID_STEP_PROPAGATION' && (
            <Space style={{ padding: '0 4px', color: token.colorErrorText }}>
              <WarningOutlined style={{ fontSize: 20 }} />
              The selected step-specific propagation doesn&apos;t support dropoff analysis for this
              step, please adjust the propagation settings or select a different step.
            </Space>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(DropoffIndicator);
